import { TSearchPromosResponse_1 } from '../repositories/newbuilding-promos/v2/search-promos';
import { IBreadcrumb } from '../types/breadcrumb';

export const mapBreadcrumbs = (promosResponse: TSearchPromosResponse_1): IBreadcrumb[] => {
  return promosResponse.breadcrumbs || [];
};
